import { ArrowRight, ArrowDown } from "lucide-react";
import { LINKS } from "../../lib/links";

// Local converted H.264 MP4 — plays cross-browser (Chrome / Safari / Firefox).
const HERO_VIDEO = "/media/hero-bg.mp4";
const HERO_POSTER = "/media/hero-poster.jpg";

const CREDIBILITY = [
  "Founder of Find My Filmmaker",
  "Built London Lighting to £400k/year",
  "Entrepreneur & Mentor",
  "Real-world business experience",
];

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-black"
    >
      {/* Background video with image fallback */}
      <div className="absolute inset-0 z-0">
        <video
          data-testid="hero-video"
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={HERO_POSTER}
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        {/* overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/20 to-black/60" />
        <div className="absolute inset-0 grain" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-[100svh] flex flex-col justify-end pb-16 md:pb-24 pt-32">
        <div className="max-w-4xl">
          <div className="reveal flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-zinc-500" />
            <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
              The Builder Programme · Invest In Yourself
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="reveal text-5xl sm:text-6xl lg:text-7xl xl:text-[6rem] leading-[0.95] tracking-tighter font-extrabold text-white"
          >
            Build income, <br className="hidden sm:block" />
            discipline and a <br className="hidden sm:block" />
            <span className="italic font-light text-zinc-200">
              real business.
            </span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="reveal mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-zinc-300/90 font-medium"
          >
            A hands-on mentorship programme for ambitious people serious about
            building something real.
          </p>

          <div className="reveal mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#apply"
              data-testid="hero-apply-btn"
              className="group inline-flex items-center justify-center gap-3 bg-white text-black font-bold text-sm tracking-[0.15em] uppercase px-7 py-4 hover:bg-zinc-200 transition-colors duration-300"
            >
              Apply To The Builder Programme
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a
              href={LINKS.ideaToIncome}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-guide-btn"
              className="group inline-flex items-center justify-center gap-3 bg-transparent text-white font-semibold text-sm tracking-[0.15em] uppercase px-7 py-4 border border-zinc-700 hover:border-white transition-colors duration-300"
            >
              Download The Free Idea-To-Income Guide
              <ArrowDown className="w-4 h-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </a>
          </div>

          {/* credibility marquee */}
          <div className="reveal mt-14 border-t border-zinc-800/80 pt-6">
            <div className="overflow-hidden">
              <div className="marquee-track flex gap-12 whitespace-nowrap">
                {[...CREDIBILITY, ...CREDIBILITY, ...CREDIBILITY].map(
                  (item, i) => (
                    <div
                      key={i}
                      className="flex items-center gap-3 text-zinc-400"
                    >
                      <span className="w-1.5 h-1.5 bg-zinc-500" />
                      <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold">
                        {item}
                      </span>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-6 right-6 md:right-12 z-10 hidden md:flex items-center gap-3 text-zinc-500">
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <span className="h-8 w-px bg-zinc-700" />
      </div>
    </section>
  );
};
